import { Paper } from "@mui/material";
import {useOutletContext} from "react-router-dom"
import { DataGrid,GridToolbarContainer,GridToolbarFilterButton, GridToolbarQuickFilter} from '@mui/x-data-grid';
import { useState } from "react";
import NewZoneDialog from "../../components/NewZoneDialog";
import ReAuthDeleteDialog from "../../components/ReAuthDeleteDialog";
import { Zone } from "../../features/db/zone";

export default function ZonesPage() {
	const { projectsContainer, zonesContainer } = useOutletContext();
	const [zones, setZones] = zonesContainer;
	const [projects] = projectsContainer;

	const [selectionModel, setSelectionModel] = useState([]);

	const columns = [
		{ field: 'project', headerName: 'Project', flex:0.5},
		{ field: 'zone', headerName: 'Zone', flex:1},
	];

	const submitCallback = (p)=>
	{
		if(p.length > 0)
		{
			setZones([...zones, ...p]);
			return;
		}
		setZones([...zones, p]);
	}

	const handleDelete = ()=>
	{
		if(selectionModel.length > 0)
		{
			Zone.deleteAndUpdate(selectionModel,zones,setZones);
		}
	}

	const CustomToolbar = ({ setFilterButtonEl }) => (
		<GridToolbarContainer sx = {{m:1}}>
			<GridToolbarQuickFilter />
			<GridToolbarFilterButton ref={setFilterButtonEl} />
			<NewZoneDialog projects={projects} submitCallback={submitCallback}/>
			<ReAuthDeleteDialog handleDelete = {handleDelete} selectionSize = {selectionModel.length}/>
		</GridToolbarContainer>
	);

	return (
		<Paper varient="outlined" sx={{m:2}} elevation={10}>
			<DataGrid
				autoHeight
				rows={zones}
				columns={columns}
				checkboxSelection
				components={{Toolbar: CustomToolbar }}
				disableColumnSelector
				disableDensitySelector
				onSelectionModelChange = {(newSelectionModel) => {
					setSelectionModel(newSelectionModel);
				}}
				selectionModel={selectionModel}
				getRowHeight={() => 'auto'}
			/>
		</Paper>
	);
}